const resources = {
    signInLead1: 'Ouvrir une session',
    signInLead2: 'pour une expérience plus personnalisée ou',
    signInLeadLink: 'créer un compte',
    signInCTA: 'Ouvrir une session',
    status: 'Vous êtes',
    points: 'avec',
    join: 'S’inscrire à Beauty Insider',
    earn: 'pour accumuler des points à chaque achat.',
    ccRewards: 'Récompenses Carte de crédit'
};

module.exports = function getResource(label) {
    return resources[label];
};
